import Services02 from "./Services02";

function main() {
  return (
    <div>
      <Services02 />
    </div>
  );
}

export default main;
